import styled from '@emotion/styled';

import { BasicFlex } from '../../../utils/Common';

import { Switch } from '@mui/material';

import { usePageData } from '../../../contexts/PageData';

const CardStyles = styled(BasicFlex)`
  padding: 1.6rem 1.6rem;
  border-radius: 5px;
  border: 1px solid ${props => props.theme.colors.border};
  background-color: white;
  cursor: pointer;
  height: 10rem;

  &:hover {
    background-color: ${props => props.theme.colors.secondaryFaint};
  }
`

const CardInfo = styled(BasicFlex)`
  flex-grow: 1;
  width: auto;
  /* min-width: 20rem; */
  gap: .6rem;
`

const CardTitle = styled.div`
  font-size: 1.6rem;
  font-weight: 500;
`

const CardDescription = styled.div`
  color: ${props => props.theme.colors.mildText};
`

const CardAction = styled.div``

const RadioCardOptions = styled(BasicFlex)`
  /* flex-wrap: wrap; */
  max-width: 100%;
`

const Card = ({ title, description, name, value, fieldName }) => {

  const { data, modifySetting } = usePageData() || {};

  let id = data?.setting_id;

  const handleChange = (e) => {
    modifySetting(name, fieldName, id);
  }

  return (
    <CardStyles align="flex-start" onClick={handleChange}>
      <CardInfo dir="column">
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardInfo>
      <CardAction>
        <Switch name={name} checked={value === name} />
      </CardAction>
    </CardStyles>
  )
};

const RadioCards = ({ options = [], fieldName}) => {

  const { data, modifySetting } = usePageData() || {};

  let values = data?.data || {};

  let value = values[fieldName];

  return (
    <RadioCardOptions justify="flex-start" gap="2rem">
      {options.map((option, index) => <Card key={option?.name} {...option} value={value} fieldName={fieldName} />)}
    </RadioCardOptions>
  )
};

export default RadioCards;